import { render, staticRenderFns } from "./UserLikesButton.vue?vue&type=template&id=2b0c1c7a&scoped=true"
import script from "./UserLikesButton.vue?vue&type=script&lang=js"
export * from "./UserLikesButton.vue?vue&type=script&lang=js"
import style0 from "./UserLikesButton.vue?vue&type=style&index=0&id=2b0c1c7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c1c7a",
  null
  
)

export default component.exports